var map = {
	"./cannes.png": 33338,
	"./deutscherkamerapreis.png": 72301,
	"./jupiter.png": 55187,
	"./lafa.png": 80356,
	"./selb.png": 47856,
	"./shokingshorts.png": 95912
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49912;